'use client';

import { c as _c } from "react/compiler-runtime";
import type { PrV2FileStoryCommentPreview } from '@/app/pr-v2/[owner]/[repo]/pull/[number]/components/diff/pr-v2-file-story-metadata-utils';
import { MessageSquare } from 'lucide-react';
import { PrV2FileStoryIssuesTooltipContent } from '@/app/pr-v2/[owner]/[repo]/pull/[number]/components/diff/pr-v2-file-header/pr-v2-file-story-header-stats/pr-v2-file-story-issues-tooltip';
import { formatReviewCommentsLabel } from '@/app/pr-v2/[owner]/[repo]/pull/[number]/components/diff/pr-v2-file-story-metadata-utils';
import { BetterTooltip } from '@/components/ui/tooltip';
type PrV2FileStoryCommentCountBadgeProps = {
  filename: string;
  commentPreviews: PrV2FileStoryCommentPreview[];
};
export function PrV2FileStoryCommentCountBadge(t0) {
  const $ = _c(14);
  const {
    filename,
    commentPreviews
  } = t0;
  if (commentPreviews.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== commentPreviews.length) {
    t1 = formatReviewCommentsLabel(commentPreviews.length);
    $[0] = commentPreviews.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const reviewCommentsLabel = t1;
  let t2;
  if ($[2] !== commentPreviews) {
    t2 = <PrV2FileStoryIssuesTooltipContent commentPreviews={commentPreviews} />;
    $[2] = commentPreviews;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `pr-v2-file-header-comments-${filename}`;
  let t4;
  if ($[4] !== commentPreviews.length) {
    t4 = <span>{commentPreviews.length}</span>;
    $[4] = commentPreviews.length;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MessageSquare className="size-3 text-zinc-500" aria-hidden="true" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== reviewCommentsLabel || $[8] !== t3 || $[9] !== t4) {
    t6 = <span aria-label={reviewCommentsLabel} className="inline-flex cursor-default items-center gap-1 px-1 py-0.5 text-xs text-zinc-500" data-testid={t3}>{t4}{t5}</span>;
    $[7] = reviewCommentsLabel;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <BetterTooltip align="end" content={t2} side="top">{t6}</BetterTooltip>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}